import { render, staticRenderFns } from "./TgHotNews.vue?vue&type=template&id=3f0076e2&"
import script from "./TgHotNews.vue?vue&type=script&lang=js&"
export * from "./TgHotNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports